import type { PropsWithChildren } from 'react';

import { FeatureFlagContext } from '../contexts/FeatureFlagContext.ts';
import { useFeatureClient } from '../hooks/useFeatureClient';

export function FeatureFlagProvider({ children }: PropsWithChildren) {
  return (
    <FeatureFlagContext.Provider value={useFeatureClient()}>
      {children}
    </FeatureFlagContext.Provider>
  );
}
FeatureFlagProvider.displayName = 'OpenFeatureClientProvider';
